import {combineReducers} from 'redux';

import app from './reactComponents/App/App.reducer.js';
import alert from './reactComponents/ModalAlert/ModalAlert.reducer.js';
import list from './reactComponents/DealList/DealList.reducer.js';
import form from './reactComponents/DealForm/DealForm.reducer.js';

export default combineReducers({
  app,
  alert,
  list,
  form
});
